module.exports = __webpack_public_path__ + "static/img/6.47ef00d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/6.png
// module id = 1maB
// module chunks = 0